<template>
  <router-view>

  </router-view>
</template>

<script>


export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
.bg-hero{
  background: #f8faff;
}
</style>
